import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BrandLogoComponent } from '@tokenbox/components';

@Component({
  selector: 'dt-signup-brand-logo',
  templateUrl: './signup-brand-logo.component.html',
  styleUrls: ['./signup-brand-logo.component.scss'],
  imports: [BrandLogoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignupBrandLogoComponent {}
